module.exports = __webpack_public_path__ + "img/symbol_11.1a67809c.png";